/** Card large module */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CardLargeComponent } from './card-large.component';

@NgModule({
    declarations: [ CardLargeComponent ],
    imports: [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      TranslateModule,
    ],
    providers: [],
    exports: [CardLargeComponent]
  })
  export class CardLargeModule { }